import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

const LanguageSelectionModal = ({ onClose }) => {
  const { i18n, t } = useTranslation();

  const handleLanguageSelect = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('languageSelected', 'true');
    onClose();
  };

  // When the modal is closed via the "X", default the language to English.
  const handleClose = () => {
    handleLanguageSelect('en');
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Overlay with enhanced blur and color */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md transition-opacity duration-300"></div>
      {/* Modal content with neumorphic/glassmorphism style and animation */}
      <div className="relative bg-white/80 dark:bg-gray-900/80 neumorphic p-8 rounded-2xl shadow-2xl z-10 max-w-md w-full border border-gray-200 dark:border-gray-700 animate-fadeInScale">
        {/* Close button using lucide X icon */}
        <button 
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 rounded-full transition-colors duration-200"
        >
          <X className="w-7 h-7" />
        </button>
        <div className="flex flex-col space-y-5 mt-2">
          <button
            onClick={() => handleLanguageSelect('en')}
            className="neumorphic-button w-full px-4 py-3 rounded-xl text-gray-800 dark:text-gray-100 font-semibold shadow-md hover:bg-green-100 dark:hover:bg-green-900/30 focus:outline-none focus:ring-2 focus:ring-green-400 transition-all duration-200"
          >
            English
          </button>
          <button
            onClick={() => handleLanguageSelect('kiny')}
            className="neumorphic-button w-full px-4 py-3 rounded-xl text-gray-800 dark:text-gray-100 font-semibold shadow-md hover:bg-green-100 dark:hover:bg-green-900/30 focus:outline-none focus:ring-2 focus:ring-green-400 transition-all duration-200"
          >
            Kinyarwanda
          </button>
          <button
            onClick={() => handleLanguageSelect('fr')}
            className="neumorphic-button w-full px-4 py-3 rounded-xl text-gray-800 dark:text-gray-100 font-semibold shadow-md hover:bg-green-100 dark:hover:bg-green-900/30 focus:outline-none focus:ring-2 focus:ring-green-400 transition-all duration-200"
          >
            French
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelectionModal;
